import {
  FETCH_ROLES,
  FETCH_ROLES_FAILURE,
  FETCH_ROLES_SUCCESS,
  CREATE_OR_UPADTE_ROLE,
  CREATE_OR_UPADTE_ROLE_SUCCESS,
  CREATE_OR_UPADTE_ROLE_FAILURE,
  CHANGE_USER_ROLE,
  CHANGE_USER_ROLE_SUCCESS,
  CHANGE_USER_ROLE_FAILURE,
  DELETE_ROLE,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_FAILURE,
  RESEND_MEMBER_INVITE,
  RESEND_MEMBER_INVITE_SUCCESS,
  RESEND_MEMBER_INVITE_FAILURE,
  DELETE_MEMBER_INVITE,
  DELETE_MEMBER_INVITE_SUCCESS,
  DELETE_MEMBER_INVITE_FAILURE,
  ACTIVATE_MEMBER,
} from '../../constants/ActionTypes';
import {
  IAllRolesPayload,
  IRole,
  ICreateOrUpdateRolePayload,
  FetchRolesAction,
  FetchRolesSuccessAction,
  FetchRolesFailureAction,
  CreateOrUpdateRoleAction,
  CreateOrUpdateRoleSuccessAction,
  CreateOrUpdateRoleFailureAction,
  ActivateMemberAction,
  DeleteRoleAction,
  DeleteRoleSuccessAction,
  DeleteRoleFailureAction,
  ResendMemberInviteAction,
  ResendMemberInviteSuccessAction,
  ResendMemberInviteFailureAction,
  DeleteMemberInviteAction,
  DeleteMemberInviteSuccessAction,
  DeleteMemberInviteFailureAction,
  ChangeUserRoleAction,
  ChangeUserRoleSuccessAction,
  ChangeUserRoleFailureAction,
} from '../../types/roles.types';

export const fetchRoles = ({
  username,
  companySlug,
}: IAllRolesPayload): FetchRolesAction => {
  return {
    type: FETCH_ROLES,
    payload: { username, companySlug },
  };
};

export const fetchRolesSuccess = (roles: IRole[]): FetchRolesSuccessAction => ({
  type: FETCH_ROLES_SUCCESS,
  payload: roles,
});

export const fetchRolesFailure = (error: string): FetchRolesFailureAction => ({
  type: FETCH_ROLES_FAILURE,
  payload: error,
});

export const createOrUpdateRole = (
  payload: ICreateOrUpdateRolePayload
): CreateOrUpdateRoleAction => ({
  type: CREATE_OR_UPADTE_ROLE,
  payload,
});

export const createOrUpdateRoleSuccess = (
  role: IRole
): CreateOrUpdateRoleSuccessAction => ({
  type: CREATE_OR_UPADTE_ROLE_SUCCESS,
  payload: role,
});

export const createOrUpdateRoleFailure = (
  error: string
): CreateOrUpdateRoleFailureAction => ({
  type: CREATE_OR_UPADTE_ROLE_FAILURE,
  payload: error,
});

export const activateMember = (payload: {
  username: string;
}): ActivateMemberAction => ({
  type: ACTIVATE_MEMBER,
  payload,
});

export const deleteRole = (payload: {
  roleSlug: string;
  companySlug?: string;
}): DeleteRoleAction => ({
  type: DELETE_ROLE,
  payload,
});

export const deleteRoleSuccess = (): DeleteRoleSuccessAction => ({
  type: DELETE_ROLE_SUCCESS,
});

export const deleteRoleFailure = (error: string): DeleteRoleFailureAction => ({
  type: DELETE_ROLE_FAILURE,
  payload: error,
});

export const resendMemberInvite = (payload: {
  inviteId: string;
}): ResendMemberInviteAction => ({
  type: RESEND_MEMBER_INVITE,
  payload,
});

export const resendMemberInviteSuccess =
  (): ResendMemberInviteSuccessAction => ({
    type: RESEND_MEMBER_INVITE_SUCCESS,
  });

export const resendMemberInviteFailure = (
  error: string
): ResendMemberInviteFailureAction => ({
  type: RESEND_MEMBER_INVITE_FAILURE,
  payload: error,
});

export const deleteMemberInvite = (payload: {
  inviteId: string;
  companySlug: string;
}): DeleteMemberInviteAction => ({
  type: DELETE_MEMBER_INVITE,
  payload,
});

export const deleteMemberInviteSuccess =
  (): DeleteMemberInviteSuccessAction => ({
    type: DELETE_MEMBER_INVITE_SUCCESS,
  });

export const deleteMemberInviteFailure = (
  error: string
): DeleteMemberInviteFailureAction => ({
  type: DELETE_MEMBER_INVITE_FAILURE,
  payload: error,
});

export const changeUserRole = (payload: {
  currentRole: string;
  newRole: string;
  email: string;
  companySlug: string;
}): ChangeUserRoleAction => ({
  type: CHANGE_USER_ROLE,
  payload,
});

export const changeUserRoleSuccess = (
  roles: IRole[]
): ChangeUserRoleSuccessAction => ({
  type: CHANGE_USER_ROLE_SUCCESS,
  payload: roles,
});

export const changeUserRoleFailure = (
  error: string
): ChangeUserRoleFailureAction => ({
  type: CHANGE_USER_ROLE_FAILURE,
  payload: error,
});

export type RolesActions =
  | FetchRolesAction
  | FetchRolesSuccessAction
  | FetchRolesFailureAction
  | CreateOrUpdateRoleAction
  | CreateOrUpdateRoleFailureAction
  | CreateOrUpdateRoleSuccessAction
  | ChangeUserRoleAction
  | ChangeUserRoleSuccessAction
  | ChangeUserRoleFailureAction
  | DeleteRoleAction
  | DeleteRoleFailureAction
  | DeleteRoleSuccessAction
  | ResendMemberInviteAction
  | ResendMemberInviteFailureAction
  | ResendMemberInviteSuccessAction;
